import { render, staticRenderFns } from "./MTabMove.vue?vue&type=template&id=191e130c&"
import script from "./MTabMove.vue?vue&type=script&lang=ts&"
export * from "./MTabMove.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports